var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 16,
    viewBox: "0 0 91 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star-rating"
  }, /*#__PURE__*/React.createElement("g", {
    id: "star_rate_black_24dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M28.3357 6.22222L26.4457 0L24.5557 6.22222H18.668L23.4746 9.65222L21.6469 15.5556L26.4457 11.9078L31.2524 15.5556L29.4246 9.65222L34.2235 6.22222H28.3357Z",
    fill: "#FCC539"
  })), /*#__PURE__*/React.createElement("g", {
    id: "star_rate_black_24dp copy 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M65.6678 6.22222L63.7778 0L61.8878 6.22222H56L60.8067 9.65222L58.9789 15.5556L63.7778 11.9078L68.5844 15.5556L66.7567 9.65222L71.5556 6.22222H65.6678Z",
    fill: "#FCC539"
  })), /*#__PURE__*/React.createElement("g", {
    id: "star_rate_black_24dp copy 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M84.3357 6.22222L82.4457 0L80.5557 6.22222H74.668L79.4746 9.65222L77.6469 15.5556L82.4457 11.9078L87.2524 15.5556L85.4246 9.65222L90.2235 6.22222H84.3357Z",
    fill: "#A9B0BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "star_rate_black_24dp copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M9.66778 6.22222L7.77778 0L5.88778 6.22222H0L4.80667 9.65222L2.97889 15.5556L7.77778 11.9078L12.5844 15.5556L10.7567 9.65222L15.5556 6.22222H9.66778Z",
    fill: "#FCC539"
  })), /*#__PURE__*/React.createElement("g", {
    id: "star_rate_black_24dp copy 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M46.9998 6.22222L45.1098 0L43.2198 6.22222H37.332L42.1387 9.65222L40.3109 15.5556L45.1098 11.9078L49.9165 15.5556L48.0887 9.65222L52.8876 6.22222H46.9998Z",
    fill: "#FCC539"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRating);
export default __webpack_public_path__ + "static/media/star-rating.4f261e8658019b8a6299f1a1f0fdd409.svg";
export { ForwardRef as ReactComponent };